// removed by extract-text-webpack-plugin
module.exports = {"link":"button__link___554m_","linkList":"button__linkList___uCrst","time":"button__time___3KJg1","detail":"button__detail___3YIiW","button":"button__button___-o18Z"};


//////////////////
// WEBPACK FOOTER
// ./src/styles/button.scss
// module id = 542
// module chunks = 0